import React from "react";
import {
  Paper,
  Box,
  Avatar,
  Typography,
  Chip,
  Stack,
  alpha,
  Tooltip,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonIcon from "@mui/icons-material/Person";
import VerifiedIcon from "@mui/icons-material/Verified";
import { capitalizeFirstLetter } from "../../../utils/hooks/dataHandler";

const ProfileHeader = ({ user, onEditProfile }) => {
  const { name, email, user_type, user_role, status } = user;

  const getUserTypeIcon = (userType) => {
    switch (userType) {
      case "admin":
        return <AdminPanelSettingsIcon />;
      case "user":
        return <PersonIcon />;
      default:
        return <PersonIcon />;
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        background: "#ffffff",
        color: "text.primary",
        border: "1px solid",
        borderColor: "divider",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: 3,
            justifyContent: "center", // Center items horizontally for all breakpoints
            width: "100%",
          }}
        >
          <Avatar
            sx={{
              width: { xs: 80, sm: 100 },
              height: { xs: 80, sm: 100 },
              fontSize: { xs: 32, sm: 40 },
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              color: "primary.main",
              boxShadow: "none", // 去掉重阴影
            }}
          >
            {name?.charAt(0).toUpperCase() || "U"}
          </Avatar>

          {/* User Info */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                width: "100%",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <Typography
                variant='h4'
                sx={{
                  fontWeight: 700,
                  color: "text.primary",
                  mb: 0,
                  textAlign: "left", // Always center
                  width: "100%",
                }}
              >
                {name}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  position: "absolute",
                  right: 0,
                }}
              >
                <Tooltip title='Edit Profile'>
                  <IconButton
                    onClick={onEditProfile}
                    sx={{
                      bgcolor: "primary.main",
                      color: "white",
                      "&:hover": { bgcolor: "primary.dark" },
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default ProfileHeader;
